import React from "react";

const bgFor = (s) => {
  if (s < 20) return "#7a1612";
  if (s < 30) return "#a01a16";
  if (s < 40) return "#3b3015";
  if (s < 50) return "#4a3d18";
  if (s < 60) return "#4a4218";
  if (s < 70) return "#3e4a18";
  if (s < 80) return "#1f5926";
  return "#16722a";
};

const textFor = (s) => (s < 30 || s >= 70 ? "#FFFFFF" : "#0A0A0A");

function Cell({ c, onSelect }) {
  const score = c.composite || 50;
  const bg = bgFor(score);
  const fg = textFor(score);
  return (
    <button
      onClick={() => onSelect && onSelect(c.symbol)}
      className="p-3 text-left transition-colors duration-150 hover:brightness-125"
      style={{ background: bg, color: fg }}
      data-testid={`heatmap-cell-${c.symbol}`}
    >
      <div className="mono text-[10px] uppercase opacity-80 tracking-wider truncate">{c.name}</div>
      <div className="heading text-xl font-bold mt-1">{Math.round(score)}</div>
      <div className="mono text-[11px] mt-0.5 opacity-90">
        {c.change_pct >= 0 ? "+" : ""}{(c.change_pct || 0).toFixed(2)}%
      </div>
    </button>
  );
}

export default function Heatmap({ cells = [], onSelect, groupBy }) {
  const groups = React.useMemo(() => {
    if (!groupBy) return null;
    const map = new Map();
    for (const c of cells) {
      const key = c[groupBy] || "Other";
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(c);
    }
    return [...map.entries()].sort((a, b) => a[0].localeCompare(b[0]));
  }, [cells, groupBy]);

  return (
    <div className="bg-surface border border-white/10 p-5" data-testid="heatmap">
      <div className="flex items-center justify-between mb-4">
        <h3 className="heading text-lg font-semibold">Market Heatmap</h3>
        <span className="overline">{groupBy ? `grouped by ${groupBy}` : "sentiment intensity"}</span>
      </div>
      {cells.length === 0 ? (
        <div className="overline py-12 text-center">no data yet</div>
      ) : groups ? (
        <div className="space-y-4">
          {groups.map(([key, items]) => (
            <div key={key} data-testid={`heatmap-group-${key}`}>
              <div className="flex items-baseline justify-between mb-2 pb-1 border-b border-white/5">
                <span className="overline">{key}</span>
                <span className="mono text-[10px] text-white/40">{items.length}</span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-px bg-white/10 border border-white/10">
                {items.map((c) => <Cell key={c.symbol} c={c} onSelect={onSelect} />)}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-px bg-white/10 border border-white/10">
          {cells.map((c) => <Cell key={c.symbol} c={c} onSelect={onSelect} />)}
        </div>
      )}
    </div>
  );
}
